var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('b-card',{staticClass:"ml-auto mr-auto",staticStyle:{"width":"50vw"}},[_c('h5',[_vm._v(_vm._s(_vm.value))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }